import { createSlice } from "@reduxjs/toolkit";

const tnmisSubmenu = createSlice({
  name: "tnmisSubmenu",
  initialState: false,
  reducers: {
    setTnmisSubmenu: (state, action) => {
      return action.payload;
    },
  },
});

export const { setTnmisSubmenu } = tnmisSubmenu.actions;
export default tnmisSubmenu.reducer;
